import type { IconProps } from "./types";

const defaultProps = {
  svgProps: {
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    focusable: false,
    "aria-hidden": true,
  },
  pathProps: {
    fill: "currentColor",
  },
};

const CircleCloseFill = ({ svgProps, pathProps }: IconProps) => {
  const mergedSvgProps = { ...defaultProps.svgProps, ...svgProps };
  const mergedPathProps = { ...defaultProps.pathProps, ...pathProps };

  return (
    <svg {...mergedSvgProps}>
      <path
        d="
          M12 22C17.5228 22 22 17.5228 22 12
          C22 6.47715 17.5228 2 12 2
          C6.47715 2 2 6.47715 2 12
          C2 17.5228 6.47715 22 12 22Z
          M9.17 7.76L12 10.59L14.83 7.76C15.22 7.37 15.85 7.37 16.24 7.76C16.63 8.15 16.63 8.78 16.24 9.17L13.41 12L16.24 14.83C16.63 15.22 16.63 15.85 16.24 16.24C15.85 16.63 15.22 16.63 14.83 16.24L12 13.41L9.17 16.24C8.78 16.63 8.15 16.63 7.76 16.24C7.37 15.85 7.37 15.22 7.76 14.83L10.59 12L7.76 9.17C7.37 8.78 7.37 8.15 7.76 7.76C8.15 7.37 8.78 7.37 9.17 7.76Z
        "
        {...mergedPathProps}
      />
    </svg>
  );
};

export default CircleCloseFill;
